import { ClientLambdaApi } from '@/api-client'

/**
 * Get list of all users with root access
 * @returns {Promise} Root users list
 */
export const getRootUsers = async () => {
  try {
    const response = await ClientLambdaApi.get('/admin/root-users')
    return response.data
  } catch (error) {
    console.error('Error fetching root users:', error)
    throw error
  }
}

/**
 * Otorga acceso root (administrador de plataforma) a un usuario existente.
 * @param {number|string} userId - ID numérico en auth_user
 * @returns {Promise<object>} Cuerpo de respuesta de la API
 */
export const grantRootUser = async (userId) => {
  const response = await ClientLambdaApi.post(`/admin/root-users/${userId}`)
  return response.data
}

/**
 * Revoca acceso root a un usuario.
 * @param {number|string} userId - ID numérico en auth_user
 * @returns {Promise<object>} Cuerpo de respuesta de la API
 */
export const revokeRootUser = async (userId) => {
  const response = await ClientLambdaApi.delete(`/admin/root-users/${userId}`)
  return response.data
}



// WEBPACK FOOTER //
// ./src/app/shared/services/rootUsersService.js